var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDestination = function SvgDestination(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 56,
    viewBox: "0 0 42 56",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 5C13.27 5 7 11.27 7 19C7 29.5 21 45 21 45C21 45 35 29.5 35 19C35 11.27 28.73 5 21 5ZM21 24C18.24 24 16 21.76 16 19C16 16.24 18.24 14 21 14C23.76 14 26 16.24 26 19C26 21.76 23.76 24 21 24Z",
    fill: "#29abe2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 45L19.8868 46.0054L21 47.2379L22.1132 46.0054L21 45ZM21 45C22.1132 46.0054 22.1134 46.0052 22.1136 46.0049L22.1145 46.004L22.117 46.0011L22.126 45.9912L22.1587 45.9546C22.172 45.9398 22.188 45.9218 22.2068 45.9007C22.2282 45.8766 22.2531 45.8485 22.2815 45.8164C22.3879 45.6959 22.5423 45.5196 22.738 45.2925C23.1292 44.8384 23.6856 44.1806 24.3522 43.3593C25.684 41.7183 27.4622 39.4164 29.2434 36.7765C31.0218 34.1407 32.8216 31.1407 34.1814 28.1055C35.5324 25.0898 36.5 21.9285 36.5 19C36.5 10.4416 29.5584 3.5 21 3.5C12.4416 3.5 5.5 10.4416 5.5 19C5.5 21.9285 6.46759 25.0898 7.8186 28.1055C9.17841 31.1407 10.9782 34.1407 12.7566 36.7765C14.5378 39.4164 16.316 41.7183 17.6478 43.3593C18.3144 44.1806 18.8708 44.8384 19.262 45.2925C19.4577 45.5196 19.6121 45.6959 19.7185 45.8164C19.7717 45.8766 19.8129 45.9229 19.8413 45.9546L19.874 45.9912L19.883 46.0011L19.8855 46.004L19.8864 46.0049C19.8866 46.0052 19.8868 46.0054 21 45ZM21 22.5C19.0684 22.5 17.5 20.9316 17.5 19C17.5 17.0684 19.0684 15.5 21 15.5C22.9316 15.5 24.5 17.0684 24.5 19C24.5 20.9316 22.9316 22.5 21 22.5Z",
    stroke: "white",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 42,
    height: 55.4757,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDestination, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/destination.eb9b38ad.svg";
export { ForwardRef as ReactComponent };